import { useState, useRef, useEffect } from "react";
import "./SearchableSelect.css";

function SearchableSelect({
  options = [],
  value = "",
  onChange,
  placeholder = "Select vendor...",
  disabled = false
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);

  // Filter options based on search query
  const filteredOptions = options.filter((opt) =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Close dropdown on click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className={`searchable-select-container ${disabled ? "disabled" : ""}`} ref={containerRef}>
      <div
        className="searchable-select-trigger"
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span className={value ? "selected-text" : "placeholder-text"}>
          {value || placeholder}
        </span>
        <span className={`select-arrow ${isOpen ? "open" : ""}`}>▾</span>
      </div>

      {isOpen && (
        <div className="searchable-select-dropdown">
          <div className="dropdown-search-wrapper">
            <span className="search-icon">🔍</span>
            <input
              type="text"
              className="dropdown-search-input"
              placeholder="Search vendor..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
            {searchTerm && (
              <button
                type="button"
                className="clear-search-btn"
                onClick={() => setSearchTerm("")}
              >
                ✕
              </button>
            )}
          </div>

          <div className="dropdown-options-list">
            {filteredOptions.length === 0 ? (
              <div className="no-options-found">No vendors match "{searchTerm}"</div>
            ) : (
              filteredOptions.map((opt, idx) => (
                <div
                  key={`${opt}-${idx}`}
                  className={`dropdown-option-item ${value === opt ? "selected" : ""}`}
                  onClick={() => {
                    onChange(opt);
                    setIsOpen(false);
                    setSearchTerm("");
                  }}
                >
                  {opt}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchableSelect;
